import { render } from "./TaskViewDetallePreparacion.vue?vue&type=template&id=0820b576&scoped=true"
import script from "./TaskViewDetallePreparacion.vue?vue&type=script&lang=js"
export * from "./TaskViewDetallePreparacion.vue?vue&type=script&lang=js"

import "./TaskViewDetallePreparacion.vue?vue&type=style&index=0&id=0820b576&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0820b576"]])

export default __exports__